import keyMirror from 'key-mirror';
import { createActions } from 'redux-actions';

export const constants = keyMirror({
    HOROSCOPE_LIST_REQUEST: null,
    HOROSCOPE_LIST_SUCCESS: null,
    HOROSCOPE_LIST_FAILURE: null,

    FIND_USER_HOROSCOPE_REQUEST: null,
    FIND_USER_HOROSCOPE_SUCCESS: null,
    FIND_USER_HOROSCOPE_FAILURE: null,

    SELECT_SINGLE_HOROSCOPE_REQUEST: null,

    SELECT_SINGLE_LIFE_EVENT_REQUEST: null,

    SELECT_HOROSCOPE_PLAN_REQUEST: null,

    USER_ACTIVE_HOROSCOPES_REQUEST: null,
    USER_ACTIVE_HOROSCOPES_SUCCESS: null,
    USER_ACTIVE_HOROSCOPES_FAILURE: null,

    CHECK_IF_LIVE_REQUEST: null,
    CHECK_IF_LIVE_SUCCESS: null,
    CHECK_IF_LIVE_FAILURE: null,

    USER_PREVIOUS_HOROSCOPES_REQUEST: null,
    USER_PREVIOUS_HOROSCOPES_SUCCESS: null,
    USER_PREVIOUS_HOROSCOPES_FAILURE: null,

    GET_NEW_SINGLE_HOROSCOPE_REQUEST: null,
    GET_NEW_SINGLE_HOROSCOPE_SUCCESS: null,
    GET_NEW_SINGLE_HOROSCOPE_FAILURE: null,

    SELECT_SELECTED_HOROSCOPE: null,

    MOONSIGN_LOOKUP_REQUEST: null,
    MOONSIGN_LOOKUP_SUCCESS: null,
    MOONSIGN_LOOKUP_FAILURE: null,

    RISING_SIGN_LOOKUP_REQUEST: null,
    RISING_SIGN_LOOKUP_SUCCESS: null,
    RISING_SIGN_LOOKUP_FAILURE: null,

    RESET_MOONSIGN_LOOKUP: null,
    RESET_RISING_SIGN_LOOKUP: null,

    GET_YEARLY_LIFE_EVENT_REQUEST: null,
    GET_YEARLY_LIFE_EVENT_SUCCESS: null,
    GET_YEARLY_LIFE_EVENT_FAILURE: null,
    RESET_YEARLY_LIFE_EVENT: null,

    PURCHASE_YEARLY_HOROSCOPE_REQUEST: null,
    PURCHASE_YEARLY_HOROSCOPE_SUCCESS: null,
    PURCHASE_YEARLY_HOROSCOPE_FAILURE: null,
    RESET_YEARLY_HOROSCOPE_PURCHASE: null,

    GET_SPECIAL_FORECAST_REQUEST: null,
    GET_SPECIAL_FORECAST_SUCCESS: null,
    GET_SPECIAL_FORECAST_FAILURE: null,
    RESET_SPECIAL_FORECAST: null,
});

export const {
    horoscopeListRequest,
    horoscopeListSuccess,
    horoscopeListFailure,
} = createActions(
    constants.HOROSCOPE_LIST_REQUEST,
    constants.HOROSCOPE_LIST_SUCCESS,
    constants.HOROSCOPE_LIST_FAILURE,
);

export const {
    findUserHoroscopeRequest,
    findUserHoroscopeSuccess,
    findUserHoroscopeFailure,
} = createActions(
    constants.FIND_USER_HOROSCOPE_REQUEST,
    constants.FIND_USER_HOROSCOPE_SUCCESS,
    constants.FIND_USER_HOROSCOPE_FAILURE,
);

export const {
    selectSingleHoroscopeRequest,
} = createActions(
    constants.SELECT_SINGLE_HOROSCOPE_REQUEST,
);

export const {
    selectSelectedHoroscope,
} = createActions(
    constants.SELECT_SELECTED_HOROSCOPE,
);

export const {
    selectSingleLifeEventRequest,
} = createActions(
    constants.SELECT_SINGLE_LIFE_EVENT_REQUEST,
);

export const {
    selectHoroscopePlanRequest,
} = createActions(
    constants.SELECT_HOROSCOPE_PLAN_REQUEST,
);

export const {
    userActiveHoroscopesRequest,
    userActiveHoroscopesSuccess,
    userActiveHoroscopesFailure,
} = createActions(
    constants.USER_ACTIVE_HOROSCOPES_REQUEST,
    constants.USER_ACTIVE_HOROSCOPES_SUCCESS,
    constants.USER_ACTIVE_HOROSCOPES_FAILURE,
);

export const {
    checkIfLiveRequest,
    checkIfLiveSuccess,
    checkIfLiveFailure,
} = createActions(
    constants.CHECK_IF_LIVE_REQUEST,
    constants.CHECK_IF_LIVE_SUCCESS,
    constants.CHECK_IF_LIVE_FAILURE,
);

export const {
    userPreviousHoroscopesRequest,
    userPreviousHoroscopesSuccess,
    userPreviousHoroscopesFailure,
} = createActions(
    constants.USER_PREVIOUS_HOROSCOPES_REQUEST,
    constants.USER_PREVIOUS_HOROSCOPES_SUCCESS,
    constants.USER_PREVIOUS_HOROSCOPES_FAILURE,
);

export const {
    getNewSingleHoroscopeRequest,
    getNewSingleHoroscopeSuccess,
    getNewSingleHoroscopeFailure,
} = createActions(
    constants.GET_NEW_SINGLE_HOROSCOPE_REQUEST,
    constants.GET_NEW_SINGLE_HOROSCOPE_SUCCESS,
    constants.GET_NEW_SINGLE_HOROSCOPE_FAILURE,
);

export const {
    moonsignLookupRequest,
    moonsignLookupSuccess,
    moonsignLookupFailure,
} = createActions(
    constants.MOONSIGN_LOOKUP_REQUEST,
    constants.MOONSIGN_LOOKUP_SUCCESS,
    constants.MOONSIGN_LOOKUP_FAILURE,
);

export const {
    risingSignLookupRequest,
    risingSignLookupSuccess,
    risingSignLookupFailure,
} = createActions(
    constants.RISING_SIGN_LOOKUP_REQUEST,
    constants.RISING_SIGN_LOOKUP_SUCCESS,
    constants.RISING_SIGN_LOOKUP_FAILURE,
);

export const {
    resetMoonsignLookup,
} = createActions(
    constants.RESET_MOONSIGN_LOOKUP,
);

export const {
    resetRisingSignLookup,
} = createActions(
    constants.RESET_RISING_SIGN_LOOKUP,
);

export const {
    getYearlyLifeEventRequest,
    getYearlyLifeEventSuccess,
    getYearlyLifeEventFailure,
} = createActions(
    constants.GET_YEARLY_LIFE_EVENT_REQUEST,
    constants.GET_YEARLY_LIFE_EVENT_SUCCESS,
    constants.GET_YEARLY_LIFE_EVENT_FAILURE,
);

export const {
    resetYearlyLifeEvent,
} = createActions(
    constants.RESET_YEARLY_LIFE_EVENT,
);

export const {
    purchaseYearlyHoroscopeRequest,
    purchaseYearlyHoroscopeSuccess,
    purchaseYearlyHoroscopeFailure,
} = createActions(
    constants.PURCHASE_YEARLY_HOROSCOPE_REQUEST,
    constants.PURCHASE_YEARLY_HOROSCOPE_SUCCESS,
    constants.PURCHASE_YEARLY_HOROSCOPE_FAILURE,
);

export const {
    resetYearlyHoroscopePurchase,
} = createActions(
    constants.RESET_YEARLY_HOROSCOPE_PURCHASE,
);

export const {
    getSpecialForecastRequest,
    getSpecialForecastSuccess,
    getSpecialForecastFailure,
} = createActions(
    constants.GET_SPECIAL_FORECAST_REQUEST,
    constants.GET_SPECIAL_FORECAST_SUCCESS,
    constants.GET_SPECIAL_FORECAST_FAILURE,
);

export const {
    resetSpecialForecast,
} = createActions(
    constants.RESET_SPECIAL_FORECAST,
);
